function loadStudiIndependen(view) {
    return () => import( /* webpackChunkName: "pertukaranpel-[request]" */ `../../views/KampusMerdeka/StudiIndependen/${view}.vue`)
}

function loadGuidanceStudiIndependen(view) {
  return () => import( /* webpackChunkName: "guidances-[request]" */ `../../views/KampusMerdeka/BimbinganStudiIndependen/${view}.vue`)
}


const route = [
    //Tipe Studi Independen
    {
        path: '/kampus-merdeka/studiindependen/tipe-studiindependen', //bebas
        name: 'StudiIndependentType', //bebas
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadStudiIndependen('TipeStudiIndependen') //menyesuaikan nama component
    },

    //Skala Studi Independen
    {
        path: '/kampus-merdeka/studiindependen/skala-studiindependen', //bebas
        name: 'StudiIndependentScale', //bebas
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadStudiIndependen('SkalaStudiIndependen') //menyesuaikan nama component
    },
    //Main Verifikasi Pendaftaran Studi Independen untuk prodi
    {
      path: '/kampus-merdeka/studiindependen/prodi-verifyregis', //bebas
      name: 'ProdiVerifyRegis', //bebas
      meta: {
      requiresAuth: true,
      roleVerif: false,
      role: []
      },
    component: loadStudiIndependen('ProdiVerifyRegistration') //menyesuaikan nama component
  },

    //Main Pendaftaran Studi Independen Mahasiswa
    {
      path: '/kampus-merdeka/studiindependen/studiindependen-mainstudent', //bebas
      name: 'MainRegistrationStudent', //bebas
      meta: {
      requiresAuth: true,
      roleVerif: false,
      role: []
      },
    component: loadStudiIndependen('MainRegistrationStudent') //menyesuaikan nama component
  },
  {
    path: '/studiindepnden-dosbim/:idpstd_id',
    name: 'DosbimStudiIndependen',
    meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
    },
    component: loadStudiIndependen('StudiIndependenAdvisor')
  },

  {
        path: '/kampus-merdeka/studiindependen-logbook/:id',
        name: 'LogbookIdpstd',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadStudiIndependen('LogbookStudiIndependen')
    },
    {
      path: '/studiindependen-rubric',
      name: 'RubricStudiIndependen',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['kaprodi','sekprodi']
      },
      component: loadStudiIndependen('RubricCategory')
    },
    {
      path: '/studiindependen-rubric/:category_id',
      name: 'RubricFieldStudiIndependen',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['kaprodi','sekprodi']
      },
      component: loadStudiIndependen('RubricField')
    },

    // Region Bimbingan

    {
      path: '/kampus-merdeka/dosen/bimbingan/idpstd/:student_id',
      name: 'MyStudentGuidancesStudiIndependen',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
      },
      component: loadGuidanceStudiIndependen('ListBimbinganMahasiswa')
    },
    {
      path: '/kampus-merdeka/dosen/bimbingan/idpstd',
      name: 'MyGuidanceStudentsStudiIndependen',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
      },
      component: loadGuidanceStudiIndependen('ListMahasiswaBimbingan')
    },
    {
      path: '/kampus-merdeka/dosen/bimbingan/idpstd/:student_id/:guidance_id',
      name: 'ResponseMyStudentGuidanceStudiIndependen',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
      },
      component: loadGuidanceStudiIndependen('ResponseBimbinganMahasiswa')
    },
    {
      path: '/kampus-merdeka/mahasiswa/bimbingan/idpstd/:guidance_id',
      name: 'ResponseGuidanceStudiIndependen',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['mahasiswa']
      },
      component: loadGuidanceStudiIndependen('ResponseBimbinganMahasiswa')
    },
    {
      path: '/kampus-merdeka/mahasiswa/bimbingan/idpstd',
      name: 'ListBimbinganStudiIndependen',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['mahasiswa']
      },
      component: loadGuidanceStudiIndependen('ListBimbingan')
    },
    {
      path: '/kampus-merdeka/form/bimbingan/idpstd',
      name: 'FormBimbinganStudiIndependen',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['mahasiswa']
      },
      component: loadGuidanceStudiIndependen('FormBimbingan')
    },

    //Region Exam
    {
      path: '/studiindependen-exam/:detail_id',
      meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
      },
      component: loadStudiIndependen('MainViewExam'),
      children: [
          {
              path: '',
              name: 'Ujian Studi Independen',
              component: loadStudiIndependen('ExamDetail')
          },
          {
              path: 'nilai-stdidp',
              name: 'Penilaian Studi Independen',
              component: loadStudiIndependen('PkmRubric')
          },
          {
              path: 'lecture',
              name: 'Penilaian Dosen Pembimbing Studi Independen',
              component: loadStudiIndependen('LectureRubric')
          },
          {
              path: 'result',
              name: 'Nilai Studi Independen',
              component: loadStudiIndependen('StudiIndependenResult')
          }
      ]
    },
    {
      path: '/studiindependen-exam',
      name: 'StudiIndependenVerifyExam',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
      },
      component: loadStudiIndependen('VerifyExam')
    },
    
    //Region Konversi
    {
      path: '/konversi-studiindependen',
      name: 'StudentConvertionViewIdpstd',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['kaprodi','administrator','sekprodi']
      },
      component: loadStudiIndependen('StudentConvertionView')
  },
  {
      path: '/konversi-studiindependen/mata-kuliah/:id',
      name: 'ConvertionViewIdpstd',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['kaprodi','administrator','sekprodi']
      },
      component: loadStudiIndependen('ConvertionView')
  },
  {
      path: '/konversi-studiindependen/mata-kuliah/:id/TU',
      name: 'ConvertionViewIdpstdAdmin',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['administrator', 'mahasiswa']
      },
      component: loadStudiIndependen('ConvertionViewAdmin')
  },

]

export default route